import React, { ReactElement } from 'react'

import { Center, Icon, IconButton, SlideFade } from '@chakra-ui/react'
import { VscFoldUp } from 'react-icons/vsc'
import { useScrollTo } from 'hooks'

type FloatingButtonProps = {
  isOpen: boolean
  reference: React.RefObject<HTMLDivElement | null>
  icon: ReactElement
  withArrow?: boolean
}

const FloatingButton = React.forwardRef<HTMLDivElement, FloatingButtonProps>(
  ({ isOpen, reference, icon, withArrow }, ref) => {
    return (
      <SlideFade in={isOpen} offsetY="20px" ref={ref}>
        <Center position="fixed" bottom={84} right={5} zIndex={44}>
          {withArrow && <Icon position="absolute" width="100%" bottom="110%" as={VscFoldUp} />}
          <IconButton
            aria-label="contact"
            boxShadow="0 0 1rem #00000029"
            onClick={useScrollTo(reference)}
            icon={icon}
            size="lg"
            colorScheme="gray"
            borderRadius="full"
          />
        </Center>
      </SlideFade>
    )
  }
)
FloatingButton.defaultProps = {
  withArrow: false
}

export default FloatingButton
